import { createRouter, createWebHistory } from 'vue-router'
const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home/Home.vue"),
    meta: {
      metaInfo: {
        title: "富佰新材料（浙江）有限公司",
        keywords: "首页, 功能钢材, 不锈钢钢筋, 不锈钢钢绞线, 传力杆",
        description: "首页：Fusteel致力于提供高性能功能钢材解决方案，包括不锈钢钢筋、不锈钢钢绞线、传力杆等产品。作为全球领先的功能钢材供应商，我们为客户提供高品质材料和专业服务。"
      }
    },
  },
  {
    path: "/stainless-steel-rebar",
    name: "Stainless-steel-rebar",
    component: () => import("../views/StainlessSteelRebar/StainlessSteelRebar.vue"),
    meta: {
      metaInfo: {
        title: "不锈钢钢筋-富佰新材料（浙江）有限公司",
        keywords: "不锈钢钢筋, 不锈钢螺纹钢, 不锈钢增强钢筋, BS6744不锈钢钢筋, ASTM A955钢筋",
        description: "不锈钢钢筋：Fusteel是全球领先的不锈钢钢筋制造商之一，提供符合BS 6744和ASTM A955/A955M标准的不锈钢钢筋产品。产品覆盖不锈钢钢筋、不锈钢传力杆、不锈钢钢筋网及连接套筒，规格范围涵盖8mm至50mm直径，为基础设施工程提供高耐腐蚀、长寿命解决方案。"
      }
    },
  },
  {
    path: "/stainless-steel-strand",
    name: "Stainless-steel-strand",
    component: () => import("../views/StainlessSteelStrand/StainlessSteelStrand.vue"),
    meta: {
      metaInfo: {
        title: "不锈钢钢绞线-富佰新材料（浙江）有限公司",
        keywords: "不锈钢钢绞线, 双相不锈钢钢绞线, 1860MPa钢绞线, 低松弛钢绞线",
        description: "不锈钢钢绞线：Fusteel不锈钢钢绞线采用双相不锈钢制造，是全球领先的不锈钢钢绞线产品之一，具有优异耐腐蚀性能，抗拉强度达到1860MPa，并具备低松弛性能，适用于高耐久性预应力工程。"
      }
    },
  },
  {
    path: "/cryogenic-rebar",
    name: "Cryogenic Rebar",
    component: () => import("../views/LowTemperature/LowTemperature.vue"),
    meta: {
      metaInfo: {
        title: "低温钢筋-富佰新材料（浙江）有限公司",
        keywords: "低温钢筋, 液化天然气钢筋, LNG钢筋, 低温合金钢筋, FusteelX低温钢筋",
        description: "低温钢筋：Fusteel低温钢筋专为极端低温环境设计，具有优异的低温韧性、耐腐蚀性能和长期稳定性，适用于LNG储罐、低温工程设施以及其他需要高可靠性的基础结构。"
      }
    },
  },
  {
    path: "/dowel-bar",
    name: "dowel bar",
    component: () => import("../views/StainlessSteelDowelBar/StainlessSteelDowelBar.vue"),
    meta: {
      metaInfo: {
        title: "传力杆-富佰新材料（浙江）有限公司",
        keywords: "不锈钢传力杆, 环氧涂层传力杆, dowel bar, 不锈钢dowel bar",
        description: "不锈钢传力杆：Fusteel Co., Ltd.提供高性能传力杆产品，包括不锈钢传力杆和环氧涂层传力杆，满足道路、机场跑道、桥梁及高耐久性混凝土结构的应用需求。"
      }
    }
  },
  {
    path: "/pt-bar",
    name: "pt bar",
    component: () => import("../views/PtBar/PtBar.vue"),
    meta: {
      metaInfo: {
        title: "不锈钢预应力钢棒-富佰新材料（浙江）有限公司",
        keywords: "不锈钢预应力钢棒, 不锈钢后张拉钢棒, 17-4PH不锈钢钢棒, 高强度预应力材料",
        description: "不锈钢预应力钢棒：FUSTEELX不锈钢后张拉系统采用热处理17-4PH不锈钢制造，抗拉强度超过1030MPa，为高性能预应力结构提供可靠解决方案。"
      }
    }
  },
  {
    path: "/epoxy-coated-rebar",
    name: "epoxy coated rebar",
    component: () => import("../views/EpoxyCoated/EpoxyCoated.vue"),
    meta: {
      metaInfo: {
        title: "环氧涂层钢筋 - 富佰新材料（浙江）有限公司",
        keywords: "Epoxy Coated Rebar",
        description: "The FUSTEELX Epoxy Coated Rebar is produced by applying an epoxy resin protective coating to the surface of ordinary steel bars using an electrostatic powder spraying and high-temperature fusion bonding process. This coating exhibits excellent resistance to chemical corrosion and does not react with acids or alkalis. Furthermore, the coating is impermeable, thus delaying contact between corrosive media (such as water, oxygen, and chlorides) and the steel bars, significantly extending their corrosion resistance lifespan."
      }
    }
  },
  {
    path: "/products",
    name: "Products",
    component: () => import("../views/Products/Products.vue"),
    meta: {
      metaInfo: {
        title: "产品列表-富佰新材料（浙江）有限公司",
        keywords: "不锈钢产品, 功能钢材, 不锈钢钢筋, 不锈钢钢绞线, 传力杆, 无磁材料",
        description: "产品列表：Fusteel提供多种高性能钢材产品，包括不锈钢钢筋、不锈钢钢绞线、传力杆、无磁钢材、功能合金材料等，为基础设施、能源工程及高端制造领域提供专业材料解决方案。"
      }
    },
  },
  {
    path: "/accessories",
    name: "accessories",
    component: () => import("../views/Others/Others.vue"),
    meta: {
      metaInfo: {
        title: "精密零磁配件 - 富佰新材料（浙江）有限公司",
        keywords:
          "无磁钢板, 无磁弹簧, 无磁套筒, 无磁焊丝, 无磁钢管, 无磁管材, 零磁材料, 低磁导率材料",
        description:
          "Fusteel（also searched as FusteelX）提供多种高性能无磁产品，包括无磁钢板、无磁弹簧、无磁套筒、无磁焊丝、无磁钢管及无磁管材。产品具有超低磁导率、高强度和优异耐腐蚀性能，广泛应用于聚变能源、半导体制造、医疗设备、国防工程以及其他对磁干扰控制要求严格的精密工程领域。"
      }
    },
  },
  {
    path: "/non-magnetic-rebar",
    name: "non-magnetic-rebar",
    component: () => import("../views/NonMagneticRebar/NonMagneticRebar.vue"),
    meta: {
      metaInfo: {
        title: "零磁钢筋 HRB400NM/HRB500NM - 富佰新材料（浙江）有限公司",
        keywords:
          "无磁钢筋, HRB400NM, HRB500NM, 零磁钢筋, 低磁导率钢筋, 无磁钢筋混凝土, 聚变能源钢筋, 半导体建筑钢筋",
        description:
          "无磁钢筋（HRB400NM/HRB500NM）：FusteelX 专业研发和制造具有超低磁导率的无磁钢筋产品。FusteelX® 无磁钢筋专为聚变能源设施、半导体制造平台、磁屏蔽结构以及其他需要严格控制磁干扰的工程应用而设计。产品相对磁导率≤1.002，300 Gauss充磁后剩余磁性≤1 nT，同时具备优异的磁稳定性、高强度和卓越耐腐蚀性能。"
      }
    },
  },
  {
    path: "/non-magnetic-fastener",
    name: "non-magnetic-fastener",
    component: () => import("../views/NonMagneticFastener/NonMagneticFastener.vue"),
    meta: {
      metaInfo: {
        title: "零磁紧固件 NMS-80/NMS-100 - 富佰新材料（浙江）有限公司",
        keywords:
          "无磁紧固件, 无磁螺栓, NMS-80, NMS-100, 零磁紧固件, 无磁不锈钢紧固件, 低磁导率紧固件, 聚变能源紧固件",
        description:
          "无磁紧固件：Fusteel Co., Ltd.生产的NMS-80/NMS-100无磁紧固件专为极端电磁环境设计，适用于聚变能源设施、MRI系统、反水雷舰艇（MCMV）、半导体制造设备以及其他对磁性能敏感的应用领域。产品相对磁导率≤1.002，300 Gauss充磁后剩余磁性≤1 nT，在冷加工、装配及长期服役过程中保持稳定的零磁性能，同时具备高机械强度、耐腐蚀性和长期使用寿命，适用于海洋、高盐雾、高湿度等严苛环境。"
      }
    },
  },
  {
    path: "/X55Ni40-Ultra",
    name: "X55Ni40-Ultra",
    component: () => import("../views/NonMagneticAlloy/NonMagneticAlloy.vue"),
    meta: {
      metaInfo: {
        title: "零磁合金 X55Ni40-Ultra - 富佰新材料（浙江）有限公司",
        keywords:
          "零磁合金, 无磁合金, X55Ni40-Ultra合金, 高强度零磁合金, 超低磁导率合金, 半导体设备合金, 低温合金",
        description:
          "零磁合金：Fusteel Co., Ltd.研发的X55Ni40-Ultra是一款用于极端电磁环境的高强度零磁合金。通过自主研发的热处理工艺，该合金无需冷加工即可实现HRC52以上硬度和超过1600 MPa抗拉强度，同时保持超低磁导率和零剩余磁性。X55Ni40-Ultra广泛应用于半导体制造设备、精密仪器、真空系统以及其他对磁稳定性、高强度、耐腐蚀性和尺寸稳定性要求极高的先进工程领域。"
      }
    },
  },
  {
    path: "/about-us",
    name: "about-us",
    component: () => import("../views/AboutUs/AboutUs.vue"),
    meta: {
      metaInfo: {
        title: "关于我们-富佰新材料（浙江）有限公司",
        keywords: "富佰新材料, Fusteel, 功能钢材制造商, 不锈钢钢筋厂家, 特种钢生产企业",
        description: "关于我们：富佰新材料（浙江）有限公司是高性能长材及功能钢材领域的专业制造商。公司拥有先进生产能力和完整供应链体系，专注于不锈钢钢筋、功能合金、无磁材料及高性能钢材产品的研发与制造，为全球客户提供高品质材料解决方案。"
      }
    }
  },
  {
    path: "/sma",
    name: "Sma",
    component: () => import("../views/SMA/Sma.vue"),
    meta: {
      metaInfo: {
        title: "铁基形状记忆合金-富佰新材料（浙江）有限公司",
        keywords: "铁基形状记忆合金, Fe-SMA, 形状记忆材料, 智能材料, 预应力材料",
        description: "铁基形状记忆合金：形状记忆合金是一类具有形状记忆效应的先进功能材料，在受力变形后能够通过热激活恢复原始形状。Fusteel提供高性能Fe-SMA铁基形状记忆合金产品，可应用于结构加固、智能工程及先进建筑领域。"
      }
    }
  },
  {
    path: "/non-magnetic",
    name: "Non-Magnetic",
    component: () => import("../views/NonMagnet/MagnetFree.vue"),
    meta: {
      metaInfo: {
        title: "零磁精密合金系列-富佰新材料（浙江）有限公司",
        keywords: "零磁材料, 无磁钢, 无磁合金, 超低磁导率材料, 零剩磁材料",
        description: "零磁精密合金系列：传统无磁钢通常包括无磁结构钢和无磁不锈钢，例如45Mn17Al3等材料，其剩磁通常达到数百至上千nT。Fusteel零磁材料专为极低磁场环境设计，剩余磁性低于1nT，满足聚变能源、半导体制造及高精度磁环境工程的严格要求。"
      }
    },
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/ContactUs/Contact.vue"),
    meta: {
      metaInfo: {
        title: "联系我们-富佰新材料（浙江）有限公司",
        keywords: "联系富佰新材料, Fusteel联系方式, 不锈钢钢筋供应商",
        description: "联系我们：如需了解Fusteel产品信息、技术支持或项目合作，请联系我们。我们将在收到您的咨询后及时回复，为客户提供专业的材料解决方案。"
      }
    },
  },
  {
    path: "/epoxy-coated-rebar",
    name: "epoxy coated rebar",
    component: () => import("../views/EpoxyCoated/EpoxyCoated.vue"),
    meta: {
      metaInfo: {
        title: "环氧涂层钢筋-富佰新材料（浙江）有限公司",
        keywords: "环氧涂层钢筋, epoxy coated rebar, 防腐钢筋, 环氧粉末涂层钢筋, 耐腐蚀钢筋",
        description: "环氧涂层钢筋：FUSTEELX环氧涂层钢筋采用静电粉末喷涂及高温熔融结合工艺，在钢筋表面形成高性能防腐保护层。该涂层具有优异的耐化学腐蚀性能，可有效阻隔水、氧气及氯离子等腐蚀介质与钢筋接触，大幅提升钢筋结构的耐久性和使用寿命。"
      }
    }
  },
  {
    path: "/warranty_book",
    name: "warranty book",
    component: () => import("../views/WarrantyBook.vue"),
    meta: {
      metaInfo: {
        title: "电子质保书平台-富佰新材料（浙江）有限公司",
        keywords: "电子质保书, 在线质保书, 产品质量证明书, Fusteel质保书",
        description: "该页面为FusteelX电子质保书平台，用于查询和展示产品质量保证文件及相关信息。"
      }
    }
  },
  {
    path: "/question",
    name: "question",
    component: () => import("../views/Question.vue"),
    meta: {
      metaInfo: {
        title: "常见问题QA-富佰新材料（浙江）有限公司",
        keywords: "Fusteel QA, 不锈钢钢筋问题, 传力杆问题, 功能钢材咨询",
        description: "常见问题：Fusteel Co., Ltd.专注于高性能长材及功能钢材研发制造，为客户提供不锈钢钢筋、钢绞线、传力杆及其他特殊钢材产品的技术支持与解决方案。"
      }
    }
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/home'
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  if (to.meta.metaInfo) {
    document.title = to.meta.metaInfo.title
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.metaInfo.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.metaInfo.description)
  }
  next();
});

export default router
